var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeleteBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19775 2.12H5.0415C5.12744 2.12 5.19775 2.039 5.19775 1.94V2.12H11.1353V1.94C11.1353 2.039 11.2056 2.12 11.2915 2.12H11.1353V3.74H12.5415V1.94C12.5415 1.14575 11.981 0.5 11.2915 0.5H5.0415C4.35205 0.5 3.7915 1.14575 3.7915 1.94V3.74H5.19775V2.12ZM15.0415 3.74H1.2915C0.945801 3.74 0.666504 4.06175 0.666504 4.46V5.18C0.666504 5.279 0.736816 5.36 0.822754 5.36H2.00244L2.48486 17.1275C2.51611 17.8948 3.06689 18.5 3.73291 18.5H12.6001C13.2681 18.5 13.8169 17.897 13.8481 17.1275L14.3306 5.36H15.5103C15.5962 5.36 15.6665 5.279 15.6665 5.18V4.46C15.6665 4.06175 15.3872 3.74 15.0415 3.74ZM12.4497 16.88H3.8833L3.41064 5.36H12.9224L12.4497 16.88Z",
    fill: "#00629B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeleteBlue);
export default __webpack_public_path__ + "static/media/ic-delete-blue.da94759d8db2b4f612d47f77f5a77e6e.svg";
export { ForwardRef as ReactComponent };